export default __webpack_public_path__ + "static/why-tecalis_04-3e5dbb47dec110f34ea542e7e015ce4a.webp";